module.exports = __webpack_public_path__ + "static/media/Cadila-Logo-fr.242dbf0d.svg";